import { Flame } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * v2.2 P3: the flame. One control for "priority call / priority research", everywhere a lead or a
 * Curative deal is shown — the table, the header, the Kanban card, the board card. Filled orange when
 * hot, an outline when not; the click never bubbles into the row or card it sits on.
 */
export function HotToggle({
  hot,
  onToggle,
  disabled = false,
  size = "sm",
  testId = "hot-toggle",
}: {
  hot: boolean;
  onToggle: (next: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md";
  testId?: string;
}) {
  return (
    <button
      type="button"
      aria-pressed={hot}
      aria-label={hot ? "Unmark hot" : "Mark hot"}
      title={hot ? "Hot — click to unmark" : "Mark hot (priority call)"}
      disabled={disabled}
      data-testid={testId}
      data-hot={hot ? "true" : "false"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle(!hot);
      }}
      className={cn(
        "inline-flex items-center justify-center rounded p-0.5 transition-colors disabled:opacity-50",
        "pointer-coarse:min-h-11 pointer-coarse:min-w-11",
        hot ? "text-orange-600 hover:text-orange-700" : "text-fg-muted/50 hover:text-orange-500",
      )}
    >
      <Flame
        className={size === "md" ? "size-5" : "size-4"}
        fill={hot ? "currentColor" : "none"}
        aria-hidden
      />
    </button>
  );
}
